import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/content";
import { EASE } from "@/lib/motion";

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-20 sm:py-32 bg-[#0B302F] text-[#FDFBF7] relative overflow-hidden grain">
      <div className="absolute top-1/3 -left-40 w-96 h-96 rounded-full bg-[#2A5C5A]/40 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 -right-40 w-[28rem] h-[28rem] rounded-full bg-[#D5B876]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-16 max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-[#D5B876]" />
            <div className="font-sans text-sm sm:text-base font-semibold tracking-[0.28em] uppercase text-[#E7D5A8]">
              Our Philosophy
            </div>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Three quiet beliefs that shape every session.
          </h2>
        </motion.div>

        <div className="space-y-0">
          {MANIFESTO.map((ch, i) => (
            <motion.div
              key={ch.no}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: EASE }}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 py-10 border-t border-[#FDFBF7]/15 items-start"
              data-testid={`manifesto-${ch.no}`}
            >
              <div className="md:col-span-2">
                <span className="font-serif text-5xl sm:text-6xl text-[#D5B876]/90 tabular-nums">
                  {ch.no}
                </span>
              </div>
              <h3 className="md:col-span-5 font-serif text-3xl sm:text-4xl leading-tight text-[#FDFBF7]">
                {ch.title}
              </h3>
              <p className="md:col-span-5 text-[#FDFBF7]/70 leading-relaxed text-lg md:pt-2">
                {ch.body}
              </p>
            </motion.div>
          ))}
          <div className="border-t border-[#FDFBF7]/15" />
        </div>
      </div>
    </section>
  );
}
